<template>
  <el-dialog :visible.sync="visible" :title="!dataForm.id ? $t('add') : $t('update')" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()" :label-width="$i18n.locale === 'en-US' ? '120px' : '80px'">
      <el-form-item label="主键" prop="id">
        <el-input v-model="dataForm.id" placeholder="主键"></el-input>
      </el-form-item>
      <el-form-item label="上传人名" prop="creatorName">
        <el-input v-model="dataForm.creatorName" placeholder="上传人名"></el-input>
      </el-form-item>
      <el-form-item label="上传人id" prop="creatorId">
        <el-input v-model="dataForm.creatorId" placeholder="上传人id"></el-input>
      </el-form-item>
      <el-form-item label="审核状态，0审核中，2未通过，1通过" prop="auditStatus">
        <el-input v-model="dataForm.auditStatus" placeholder="审核状态，0审核中，2未通过，1通过"></el-input>
      </el-form-item>
      <el-form-item label="内容描述" prop="context">
        <el-input v-model="dataForm.context" placeholder="内容描述"></el-input>
      </el-form-item>
      <el-form-item label="链接" prop="link">
        <el-input v-model="dataForm.link" placeholder="链接"></el-input>
      </el-form-item>
      <el-form-item label="图片" prop="imgSrc">
        <el-input v-model="dataForm.imgSrc" placeholder="图片"></el-input>
      </el-form-item>
      <el-form-item label="图片绝对路径" prop="absolutePath">
        <el-input v-model="dataForm.absolutePath" placeholder="图片绝对路径"></el-input>
      </el-form-item>
      <el-form-item label="视频地址" prop="videoSrc">
        <el-input v-model="dataForm.videoSrc" placeholder="视频地址"></el-input>
      </el-form-item>
      <el-form-item label="视频绝对路径" prop="videoAbsolutePath">
        <el-input v-model="dataForm.videoAbsolutePath" placeholder="视频绝对路径"></el-input>
      </el-form-item>
      <el-form-item label="重新提交反馈" prop="resubmit">
        <el-input v-model="dataForm.resubmit" placeholder="重新提交反馈"></el-input>
      </el-form-item>
      <el-form-item label="通过时间" prop="passTime">
        <el-input v-model="dataForm.passTime" placeholder="通过时间"></el-input>
      </el-form-item>
      <el-form-item label="点赞数" prop="sponsorNum">
        <el-input v-model="dataForm.sponsorNum" placeholder="点赞数"></el-input>
      </el-form-item>
      <el-form-item label="创建者" prop="creator">
        <el-input v-model="dataForm.creator" placeholder="创建者"></el-input>
      </el-form-item>
      <el-form-item label="更新者" prop="updater">
        <el-input v-model="dataForm.updater" placeholder="更新者"></el-input>
      </el-form-item>
      <el-form-item label="创建时间" prop="createDate">
        <el-input v-model="dataForm.createDate" placeholder="创建时间"></el-input>
      </el-form-item>
      <el-form-item label="更新时间" prop="updateDate">
        <el-input v-model="dataForm.updateDate" placeholder="更新时间"></el-input>
      </el-form-item>
      <el-form-item label="学校id" prop="schoolId">
        <el-input v-model="dataForm.schoolId" placeholder="学校id"></el-input>
      </el-form-item>
    </el-form>
    <template slot="footer">
      <el-button @click="visible = false">{{ $t('cancel') }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()">{{ $t('confirm') }}</el-button>
    </template>
  </el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'
export default {
  data () {
    return {
      visible: false,
      dataForm: {
        id: '',
        creatorName: '',
        creatorId: '',
        auditStatus: '',
        context: '',
        link: '',
        imgSrc: '',
        absolutePath: '',
        videoSrc: '',
        videoAbsolutePath: '',
        resubmit: '',
        passTime: '',
        sponsorNum: '',
        creator: '',
        updater: '',
        createDate: '',
        updateDate: '',
        schoolId: '',
      }
    }
  },
  computed: {
    dataRule () {
      return {
      }
    }
  },
  methods: {
    init () {
      this.visible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].resetFields()
        if (this.dataForm.id) {
          this.getInfo()
        }
      })
    },
    // 获取信息
    getInfo () {
      this.$http.get('/style/classstyle/' + this.dataForm.id).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.dataForm = {
          ...this.dataForm,
          ...res.data
        }
      }).catch(() => {})
    },
    // 表单提交
    dataFormSubmitHandle: debounce(function () {
      this.$refs['dataForm'].validate((valid) => {
        if (!valid) {
          return false
        }
        this.$http[!this.dataForm.id ? 'post' : 'put']('/style/classstyle/', this.dataForm).then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.visible = false
              this.$emit('refreshDataList')
            }
          })
        }).catch(() => {})
      })
    }, 1000, { 'leading': true, 'trailing': false })
  }
}
</script>
